<div class="ovulation_indeuction header_top mb-5">
  <section class="ovulation_induction_banner">
    <div class="container">
      <div class="banner_content">
        <h6>Fertility Preservation</h6>
        <h5>Secure Your Future with cryopreservation</h5>
        <p>
          Life’s plans can change - but your fertility doesn’t have to. At NCare
          IVF Kannur, Kerala, we offer advanced freezing and preservation
          services, including egg freezing, embryo freezing, and sperm freezing,
          allowing you to preserve your fertility and plan parenthood on your
          terms.
        </p>
        <p>Preserve today - Plan tomorrow</p>
        <button (click)="contactus()">Book a Consultation</button>
      </div>
    </div>
  </section>
  <section class="how_does_work_ivf mt-5">
    <div class="container">
      <div class="row aic">
        <div class="col-lg-7 col-md-7 col-sm-12">
          <h6>Who Can Benefit from Fertility Preservation?</h6>
          <ul>
            <li>Women wishing to delay childbearing</li>
            <li>
              Women with medical conditions requiring fertility protection
              (cancer treatment, endometriosis surgery, etc.)
            </li>
            <li>
              Couples undergoing IVF, wishing to store embryos for future use
            </li>
            <li>
              Men undergoing medical treatments or surgeries that may affect
              fertility
            </li>
            <li>
              Individuals in high-risk occupations or with lifestyle factors
              impacting fertility
            </li>
          </ul>
        </div>
        <div class="col-lg-3 col-md-3 col-sm-12">
          <img
            loading="lazy"
            src="../../../assets/images/freezing_preservation/fertility_preservation.webp"
            alt=""
          />
        </div>
      </div>
    </div>
  </section>

  <section class="freezing_section mt-5 egg_freezing">
    <div class="container">
      <div class="wrapper">
        <h4 class="title_header tac">Egg Freezing (Oocyte Cryopreservation)</h4>
        <p class="title_para">
          Egg freezing is an excellent option for women who wish to preserve
          their fertility for future use.
        </p>

        <div class="section">
          <h2>Ideal Candidates:</h2>
          <ul>
            <li>Women under 35 looking to delay motherhood</li>
            <li>
              Women diagnosed with conditions affecting fertility (PCOS,
              endometriosis)
            </li>
            <li>
              Women undergoing chemotherapy or other treatments that can harm
              ovarian reserve
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>How It Works:</h2>
          <ul>
            <li>Ovarian stimulation with fertility medications</li>
            <li>Egg retrieval via a minor outpatient procedure</li>
            <li>
              Vitrification (fast-freezing) of mature eggs for long-term storage
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>Benefits of Egg Freezing:</h2>
          <ul>
            <li>Allows women to conceive with their own eggs later in life</li>
            <li>Prevents age-related decline in egg quality</li>
            <li>
              Non-invasive beyond the initial retrieval and medication cycle
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="embryo_freezing mt-5">
    <div class="container">
      <div class="wrapper">
        <h4 class="title_header tac">Embryo Freezing</h4>
        <p class="title_para">
          Embryo freezing is often part of IVF cycles, where excess embryos are
          preserved for future pregnancies.
        </p>
        <div class="section">
          <h2>Ideal Candidates:</h2>
          <ul>
            <li>Couples undergoing IVF with surplus high-quality embryos</li>
            <li>
              Couples planning to delay implantation due to medical or personal
              reasons
            </li>
            <li>
              Individuals undergoing fertility preservation before cancer
              treatment
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>How It Works:</h2>
          <ul>
            <li>Eggs are fertilized with sperm in the lab</li>
            <li>High-quality embryos are frozen using vitrification</li>
            <li>Stored safely for use in future IVF cycles</li>
          </ul>
        </div>

        <div class="section">
          <h2>Benefits of Embryo Freezing:</h2>
          <ul>
            <li>High survival rates with vitrification</li>
            <li>
              Convenient for planning second pregnancies without undergoing
              another stimulation cycle
            </li>
            <li>Reduces the need for repeated IVF cycles</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="sperm_freezing mt-5">
    <div class="container">
      <div class="wrapper">
        <h4 class="title_header tac">Sperm Freezing</h4>
        <p class="title_para">
          Sperm freezing (sperm cryopreservation) is a simple, non-invasive
          process that allows men to preserve their fertility.
        </p>

        <div class="section">
          <h2>Ideal Candidates:</h2>
          <ul>
            <li>
              Men undergoing chemotherapy, radiation, or surgeries impacting
              fertility
            </li>
            <li>Men with low sperm counts or declining fertility</li>
            <li>
              Men who are away due to professional commitments or lifestyle
              constraints during fertility treatments
            </li>
          </ul>
        </div>

        <div class="section">
          <h2>How It Works:</h2>
          <ul>
            <li>Semen sample collection</li>
            <li>Evaluation of sperm quality and motility</li>
            <li>Freezing and storage in liquid nitrogen for long-term use</li>
          </ul>
        </div>

        <div class="section">
          <h2>Benefits of Sperm Freezing:</h2>
          <ul>
            <li>Easy, quick, and completely non-invasive</li>
            <li>
              Long-term storage (over 10 years with no decline in viability)
            </li>
            <li>Can be used in IUI, IVF, or ICSI treatments in the future</li>
          </ul>
        </div>
      </div>
    </div>
  </section>
  <section class="pink_bg_content mt-5">
    <div class="container">
      <div class="pink_bg_content_child">
        <!-- <h5>CTA BANNER CONTENT</h5> -->
        <p>
          Take control of your fertility with safe and reliable preservation.
        </p>
        <button (click)="contactus()">Book a Consultation</button>
      </div>
    </div>
  </section>
  <section class="why_choose_ncare_ivf_kannur mt-5">
    <div class="container">
      <h4 class="title_header tac">
        Why Choose NCare IVF Kannur, Kerala for Fertility Preservation?
      </h4>
      <div class="row">
        <span></span>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/freezing_preservation/ivf_fp_1.svg"
              alt=""
            />
            <h5>Advanced Freezing Technology</h5>
            <p>
              Vitrification and liquid nitrogen storage for superior survival
              rates.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/freezing_preservation/ivf_fp_2.svg"
              alt=""
            />
            <h5>Highly Experienced Embryologists</h5>
            <p>Expert handling for delicate reproductive material.</p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/freezing_preservation/ivf_fp_3.svg"
              alt=""
            />
            <h5>Secure Long-Term Storage</h5>
            <p>
              Reliable cryostorage facilities with continuous quality checks.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/freezing_preservation/ivf_fp_4.svg"
              alt=""
            />
            <h5>Personalized Fertility Planning</h5>
            <p>
              We guide patients with tailored fertility preservation strategies.
            </p>
          </div>
        </div>
        <div class="col-lg-4 col-md-4 col-sm-12">
          <div class="wcnivfk">
            <img
              loading="lazy"
              src="../../../assets/images/freezing_preservation/ivf_fp_5.svg"
              alt=""
            />
            <h5>Trusted Care</h5>
            <p>
              Confidential, professional, and compassionate fertility care in
              Kannur.
            </p>
          </div>
        </div>
      </div>
    </div>
  </section>

  <section class="what_we_provide mt-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-6 col-md-6 col-sm-12">
          <img
            loading="lazy"
            src="../../assets/images/treatment/what_we_provide.webp"
            alt=""
          />
        </div>
        <div class="col-lg-6 col-md-6 col-sm-12">
          <h6>Success Rates of Freezing & Preservation</h6>
          <ul>
            <li>
              <span>Egg Freezing:</span>– Best success rates when eggs are
              frozen before age 35; high thaw survival rates (90–95%).
            </li>
            <li>
              <span>Embryo Freezing:</span> – Embryos frozen via vitrification
              have implantation rates comparable to fresh transfers.
            </li>
            <li>
              <span>Sperm Freezing:</span> – Sperm remains viable for decades
              with successful outcomes in assisted reproduction.
            </li>
          </ul>
        </div>
      </div>
    </div>
  </section>

  <section class="faq mt-5">
    <h4 class="title_header tac">Frequently Asked Questions</h4>
    <div class="container">
      <div class="accordion" id="accordionExample">
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseOne"
              aria-expanded="true"
              aria-controls="collapseOne"
            >
              How long can eggs, sperm, and embryos be stored?
            </button>
          </h2>
          <div
            id="collapseOne"
            class="accordion-collapse collapse show"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              They can be stored for 10+ years without loss of quality, as per
              medical guidelines.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseTwo"
              aria-expanded="false"
              aria-controls="collapseTwo"
            >
              Is freezing safe for future use?
            </button>
          </h2>
          <div
            id="collapseTwo"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              Yes, with modern techniques, frozen reproductive material
              maintains high viability and success rates in future treatments.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseThree"
              aria-expanded="false"
              aria-controls="collapseThree"
            >
              What is the ideal age for egg freezing?
            </button>
          </h2>
          <div
            id="collapseThree"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              The most successful outcomes occur when eggs are frozen between
              ages 25 and 35.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFour"
              aria-expanded="false"
              aria-controls="collapseFour"
            >
              Does sperm freezing impact sperm health?
            </button>
          </h2>
          <div
            id="collapseFour"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              No. Sperm freezing and thawing preserve motility and function for
              use in IUI, IVF, and ICSI.
            </div>
          </div>
        </div>
        <div class="accordion-item">
          <h2 class="accordion-header">
            <button
              class="accordion-button collapsed"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#collapseFive"
              aria-expanded="false"
              aria-controls="collapseFive"
            >
              What happens when I’m ready to use my frozen eggs, embryos, or
              sperm?
            </button>
          </h2>
          <div
            id="collapseFive"
            class="accordion-collapse collapse"
            data-bs-parent="#accordionExample"
          >
            <div class="accordion-body">
              They will be thawed and used in assisted reproductive treatments
              with guidance from your fertility specialist.
            </div>
          </div>
        </div>
      </div>
      <button class="contact_us_info" (click)="contactus()">
        Contact Us for more information
      </button>
    </div>
  </section>
</div>
